const API_BASE_URL = process.env.REACT_APP_ADMIN_API_URL || "https://bcswebadmin.vercel.app/api";

export async function fetchFromAPI(endpoint) {
  try {
    const res = await fetch(`${API_BASE_URL}${endpoint}`);

    if (!res.ok) {
      throw new Error(`Failed to fetch ${endpoint}`);
    }

    const json = await res.json();

    // Check if the API returned a wrapped response object { success, data }
    if (json && typeof json === 'object' && 'success' in json) {
      if (!json.success) {
        throw new Error(json.error || "Unknown API error");
      }
      return json.data;
    }

    // Some endpoints (like /news or /events) simply return the raw Array/Object directly
    // Some endpoints (like /news or /events) simply return the raw Array/Object directly
    return json;

  } catch (error) {
    console.error("API Error:", error);
    return null;
  }
}
